import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    height: '100%',
    width: 'calc(100% - 4rem)',
    boxSizing: 'border-box',
    maxWidth: '100rem',
    margin: '2rem auto',
    minHeight: '90vh',
  },
}));

export default useStyles;
